// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const ProjectCountAndReviewAggregateTheme: ThemeFile = {
  aw: {
    classes: {},
  },
  rba: {
    classes: {
      container: 'col-span-12 font-bold text-black text-left',
      headline: 'items-top font-sans text-s text-secondary font-medium',
      ratingsWrapper:
        'flex flex-row w-full [.component-placeholder--container-rail_&]:w-full [.component-placeholder--container-rail_&]:gap-xs gap-xs lg:w-auto lg:gap-xl',
      totalProjectWrapper:
        'lg:w-auto [.component-placeholder--container-rail_&]:w-1/2 [.component-placeholder--container-rail_&]:py-s w-1/2 px-0 py-m flex flex-col justify-start',
      label: 'text-xxs',
      totalProjectCount: 'text-l',
      ratingsTextWrapper:
        'lg:w-auto [.component-placeholder--container-rail_&]:w-1/2 w-1/2 [.component-placeholder--container-rail_&]:mt-xxxs [.component-placeholder--container-rail_&]:py-s px-0 py-m flex flex-col justify-start text-xxs',
      ratingsIconsList: 'flex justify-start items-center mb-xxs',
      totalReviewsText: 'flex items-start',
      ratingText: 'ml-1',
    },
  },
};
